import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaArrowLeft, 
  FaBus, 
  FaCalendarAlt, 
  FaMapMarkerAlt, 
  FaUserFriends,
  FaTicketAlt,
  FaPrint,
  FaDownload,
  FaShareAlt,
  FaStar,
  FaClock,
  FaCheckCircle,
  FaTimesCircle
} from 'react-icons/fa';
import { MdAccessTime, MdEventSeat } from 'react-icons/md';
import logo from '../../components/assets/logos/logo2.PNG';

const MyBookings = () => {
  const [activeTab, setActiveTab] = useState('upcoming');

  const bookings = {
    upcoming: [
      {
        id: 'BMS2024001',
        busName: 'Volvo AC Sleeper',
        operator: 'Green Line Travels',
        from: 'New York',
        to: 'Boston',
        departure: '08:00 AM, 25 Dec 2024',
        arrival: '02:30 PM, 25 Dec 2024',
        seats: ['A2', 'A3'],
        passengers: 2,
        totalAmount: 2400,
        status: 'Confirmed',
        boardingPoint: 'Central Bus Terminal, Gate 3',
        pnr: 'PNR789456123',
        bookingDate: '20 Dec 2024'
      }
    ],
    completed: [
      {
        id: 'BMS2023125',
        busName: 'Mercedes-Benz Multi-Axle',
        operator: 'Orange Tours',
        from: 'Los Angeles',
        to: 'San Francisco',
        departure: '10:30 AM, 15 Dec 2024',
        arrival: '05:00 PM, 15 Dec 2024',
        seats: ['B1'],
        passengers: 1,
        totalAmount: 950,
        status: 'Completed',
        rating: 4.5
      }
    ],
    cancelled: []
  };

  const styles = {
    container: {
      minHeight: '100vh',
      background: 'white', // Changed from gradient to solid #FFFDE7
fontFamily: "'Noto Serif Devanagari', serif",

    },
    header: {
      background: 'linear-gradient(135deg, #FFF9C4 0%, #FFECB3 100%)', // Changed to yellow gradient
      color: '#5D4037', // Changed text color to brown
      padding: '20px 40px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
    },
    headerContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      maxWidth: '1200px',
      margin: '0 auto'
    },
    logoContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px'
    },
    logoLink: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      textDecoration: 'none',
      color: '#5D4037' // Changed to brown
    },
    logoImage: {
      height: '50px',
      width: 'auto',
      objectFit: 'contain',
      borderRadius: '8px'
    },
    logoText: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      letterSpacing: '0.5px'
    },
    mainContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '30px 20px'
    },
    tabs: {
      display: 'flex',
      gap: '10px',
      marginBottom: '30px',
      background: 'white',
      borderRadius: '12px',
      padding: '5px',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
    },
    tab: {
      flex: 1,
      padding: '15px 20px',
      border: 'none',
      background: 'transparent',
      borderRadius: '8px',
      fontSize: '1rem',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      color: '#666' // Changed to gray
    },
    tabActive: {
      background: '#FFB300', // Changed to yellow
      color: '#5D4037', // Changed to brown
      boxShadow: '0 4px 12px rgba(255, 179, 0, 0.3)' // Changed to yellow
    },
    bookingCard: {
      background: 'white',
      borderRadius: '15px',
      padding: '25px',
      marginBottom: '20px',
      boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
      borderLeft: '4px solid #FFB300' // Changed to yellow
    },
    bookingHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
      paddingBottom: '15px',
      borderBottom: '1px solid #eee'
    },
    bookingId: {
      fontSize: '1.1rem',
      fontWeight: '600',
      color: '#333'
    },
    status: {
      padding: '6px 15px',
      borderRadius: '20px',
      fontSize: '0.9rem',
      fontWeight: '600'
    },
    statusConfirmed: {
      background: '#FFF9C4', // Changed to yellow
      color: '#5D4037' // Changed to brown
    },
    statusCompleted: {
      background: '#E8F5E9', // Changed to green (keeping for status clarity)
      color: '#2E7D32'
    },
    statusCancelled: {
      background: '#FFEBEE',
      color: '#C62828'
    },
    bookingDetails: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '20px',
      marginBottom: '25px'
    },
    detailItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    detailIcon: {
      color: '#FFB300', // Changed to yellow
      fontSize: '1.2rem',
      minWidth: '24px'
    },
    detailText: {
      display: 'flex',
      flexDirection: 'column'
    },
    detailLabel: {
      fontSize: '0.8rem',
      color: '#888'
    },
    detailValue: {
      fontSize: '1rem',
      fontWeight: '600',
      color: '#333'
    },
    bookingFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: '20px',
      borderTop: '1px solid #eee'
    },
    amount: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#FFB300' // Changed to yellow
    },
    actionButtons: {
      display: 'flex',
      gap: '10px'
    },
    actionButton: {
      padding: '10px 20px',
      borderRadius: '8px',
      fontSize: '0.9rem',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      border: '2px solid'
    },
    btnPrimary: {
      background: '#FFB300', // Changed to yellow
      borderColor: '#FFB300', // Changed to yellow
      color: '#5D4037' // Changed to brown
    },
    btnSecondary: {
      background: 'white',
      borderColor: '#e0e0e0',
      color: '#666'
    },
    noBookings: {
      textAlign: 'center',
      padding: '60px 20px',
      color: '#666'
    },
    quickStats: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '20px',
      marginBottom: '40px'
    },
    statCard: {
      background: 'white',
      borderRadius: '15px',
      padding: '25px',
      boxShadow: '0 5px 20px rgba(0, 0, 0, 0.08)',
      textAlign: 'center',
      transition: 'transform 0.3s ease'
    },
    statValue: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: '#FFB300', // Changed to yellow
      marginBottom: '10px'
    },
    statLabel: {
      fontSize: '1rem',
      color: '#666'
    },
    footer: {
      background: '#FFF9C4', // Changed to yellow
      color: '#5D4037', // Changed to brown
      padding: '40px 20px',
      marginTop: '60px'
    },
    footerContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '40px'
    },
    footerSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px'
    },
    footerTitle: {
      fontSize: '1.2rem',
      fontWeight: '600',
      marginBottom: '10px'
    },
    footerLink: {
      color: '#795548', // Changed to brown
      textDecoration: 'none',
      fontSize: '0.9rem',
      transition: 'color 0.3s ease'
    },
    footerLinkHover: {
      color: '#5D4037' // Darker brown on hover
    },
    copyright: {
      textAlign: 'center',
      padding: '20px',
      borderTop: '1px solid #FFE082', // Changed to light yellow
      marginTop: '40px',
      fontSize: '0.9rem',
      color: '#795548' // Changed to brown
    }
  };

  const getStatusStyle = (status) => {
    switch(status) {
      case 'Confirmed': return { ...styles.status, ...styles.statusConfirmed };
      case 'Completed': return { ...styles.status, ...styles.statusCompleted };
      case 'Cancelled': return { ...styles.status, ...styles.statusCancelled };
      default: return styles.status;
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.logoContainer}>
            <Link to="/user-bus-finder" style={styles.logoLink}>
              <FaArrowLeft style={{ fontSize: '1.2rem' }} />
              <img src={logo} alt="Bus Management System Logo" style={styles.logoImage} />
              <span style={styles.logoText}>My Bookings</span>
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main style={styles.mainContent}>
        {/* Quick Stats */}
        <div style={styles.quickStats}>
          <div style={styles.statCard}>
            <div style={styles.statValue}>{bookings.upcoming.length}</div>
            <div style={styles.statLabel}>Upcoming Trips</div>
          </div>
          <div style={styles.statCard}>
            <div style={styles.statValue}>{bookings.completed.length}</div>
            <div style={styles.statLabel}>Completed Trips</div>
          </div>
          <div style={styles.statCard}>
            <div style={styles.statValue}>{bookings.cancelled.length}</div>
            <div style={styles.statLabel}>Cancelled Trips</div>
          </div>
          <div style={styles.statCard}>
            <div style={styles.statValue}>₹{bookings.upcoming.reduce((sum, b) => sum + b.totalAmount, 0)}</div>
            <div style={styles.statLabel}>Total Spent</div>
          </div>
        </div>

        {/* Tabs */}
        <div style={styles.tabs}>
          <button
            style={{
              ...styles.tab,
              ...(activeTab === 'upcoming' ? styles.tabActive : {})
            }}
            onClick={() => setActiveTab('upcoming')}
          >
            <FaClock /> Upcoming ({bookings.upcoming.length})
          </button>
          <button
            style={{
              ...styles.tab,
              ...(activeTab === 'completed' ? styles.tabActive : {})
            }}
            onClick={() => setActiveTab('completed')}
          >
            <FaCheckCircle /> Completed ({bookings.completed.length})
          </button>
          <button
            style={{
              ...styles.tab,
              ...(activeTab === 'cancelled' ? styles.tabActive : {})
            }}
            onClick={() => setActiveTab('cancelled')}
          >
            <FaTimesCircle /> Cancelled ({bookings.cancelled.length})
          </button>
        </div>

        {/* Bookings List */}
        {bookings[activeTab].length > 0 ? (
          bookings[activeTab].map(booking => (
            <div key={booking.id} style={styles.bookingCard}>
              <div style={styles.bookingHeader}>
                <div style={styles.bookingId}>
                  <FaTicketAlt style={{ marginRight: '10px', color: '#FFB300' }} /> {/* Changed to yellow */}
                  Booking ID: {booking.id}
                </div>
                <div style={getStatusStyle(booking.status)}>
                  {booking.status}
                </div>
              </div>

              <div style={styles.bookingDetails}>
                <div style={styles.detailItem}>
                  <FaBus style={styles.detailIcon} />
                  <div style={styles.detailText}>
                    <div style={styles.detailLabel}>Bus Name</div>
                    <div style={styles.detailValue}>{booking.busName}</div>
                  </div>
                </div>
                <div style={styles.detailItem}>
                  <FaMapMarkerAlt style={styles.detailIcon} />
                  <div style={styles.detailText}>
                    <div style={styles.detailLabel}>Route</div>
                    <div style={styles.detailValue}>{booking.from} → {booking.to}</div>
                  </div>
                </div>
                <div style={styles.detailItem}>
                  <MdAccessTime style={styles.detailIcon} />
                  <div style={styles.detailText}>
                    <div style={styles.detailLabel}>Departure</div>
                    <div style={styles.detailValue}>{booking.departure}</div>
                  </div>
                </div>
                <div style={styles.detailItem}>
                  <MdEventSeat style={styles.detailIcon} />
                  <div style={styles.detailText}>
                    <div style={styles.detailLabel}>Seats</div>
                    <div style={styles.detailValue}>{booking.seats.join(', ')}</div>
                  </div>
                </div>
              </div>

              <div style={styles.bookingFooter}>
                <div style={styles.amount}>₹{booking.totalAmount}</div>
                <div style={styles.actionButtons}>
                  {activeTab === 'upcoming' && (
                    <>
                      <button style={{ ...styles.actionButton, ...styles.btnPrimary }}>
                        <FaPrint /> Print Ticket
                      </button>
                      <button style={{ ...styles.actionButton, ...styles.btnSecondary }}>
                        Cancel Booking
                      </button>
                    </>
                  )}
                  {activeTab === 'completed' && (
                    <>
                      <button style={{ ...styles.actionButton, ...styles.btnPrimary }}>
                        <FaStar /> Rate Journey
                      </button>
                      <button style={{ ...styles.actionButton, ...styles.btnSecondary }}>
                        <FaDownload /> Download Invoice
                      </button>
                    </>
                  )}
                  <button style={{ ...styles.actionButton, ...styles.btnSecondary }}>
                    <FaShareAlt /> Share
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div style={styles.noBookings}>
            <FaBus style={{ fontSize: '4rem', color: '#e0e0e0', marginBottom: '20px' }} />
            <h3>No {activeTab} bookings found</h3>
            <p>Start booking your next trip!</p>
            <Link to="/user-bus-finder" style={{
              display: 'inline-block',
              marginTop: '20px',
              padding: '12px 30px',
              background: '#FFB300', // Changed to yellow
              color: '#5D4037', // Changed to brown
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600'
            }}>
              Book a Bus
            </Link>
          </div>
        )}
      </main>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerContent}>
          <div style={styles.footerSection}>
            <h4 style={styles.footerTitle}>Bus Management System</h4>
            <p style={{ color: '#795548', fontSize: '0.9rem' }}> {/* Changed to brown */}
              Your travel companion for safe and comfortable journeys.
            </p>
          </div>
          <div style={styles.footerSection}>
            <h4 style={styles.footerTitle}>Need Help?</h4>
            <Link to="/help" style={styles.footerLink}>Customer Support</Link>
            <Link to="/faq" style={styles.footerLink}>FAQ</Link>
            <Link to="/contact" style={styles.footerLink}>Contact Us</Link>
          </div>
          <div style={styles.footerSection}>
            <h4 style={styles.footerTitle}>Policies</h4>
            <Link to="/cancellation" style={styles.footerLink}>Cancellation Policy</Link>
            <Link to="/privacy" style={styles.footerLink}>Privacy Policy</Link>
            <Link to="/terms" style={styles.footerLink}>Terms of Service</Link>
          </div>
        </div>
        <div style={styles.copyright}>
          © {new Date().getFullYear()} Bus Management System. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default MyBookings;